import { PhoneBluetoothIcon } from './PhoneBluetoothIcon';

/**
 * author: Google
 * id 34F52268-8571-4501-93C1-D4BF606BB10E
 * name phone-bluetooth
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone-bluetooth.svg
 * tags
 * - Cellphone / Phone 
 */
export const TelephoneBluetoothIcon = PhoneBluetoothIcon;
export default TelephoneBluetoothIcon